<template>
    <div id="app" class="wrapper" v-resize:debounce.50="onResize">
        <main-loader v-if="isLoading"></main-loader>
        <template v-if="isAuthenticated">
            <password-change v-if="isFirstLogin" />
            <top-bar/>
            <div id="wrapper">
                <side-bar/>
                <div id="content-wrapper">
                    <bread-crumbs/>
                    <!-- <vue-page-transition name="fade"> -->
                    <router-view/>
                    <!-- </vue-page-transition> -->
                    <!-- <router-view/> -->
                    <main-footer/>
                </div>
            </div>
        </template>
        <template v-else>
            <router-view/>
        </template>
    </div>
</template>
<script>
import {
    mapGetters
} from 'vuex'
import {
    SET_TOGGLE
} from '@/store/mutations.type'
import resize from 'vue-resize-directive'
export default {
    name: 'app',
    components: {
        MainLoader: () => import('@/views/partials/MainLoader'),
        BreadCrumbs: () => import('@/views/partials/BreadCrumbs'),
        TopBar: () => import('@/views/partials/TopBar'),
        SideBar: () => import('@/views/partials/SideBar'),
        MainFooter: () => import('@/views/partials/MainFooter'),
        PasswordChange: () => import('@/views/partials/PasswordChange')
    },
    computed: {
        ...mapGetters([
            'isAuthenticated',
            'isFirstLogin',
            'isLoading'
        ])
    },
    directives: {
        resize
    },
    methods: {
        onResize () {
            if (window.innerWidth < 768) this.$store.commit(SET_TOGGLE, true)
        }
    }
}
</script>
<style lang="scss">
@import "./assets/scss/style";
</style>
